import React from 'react'
import ErrorIcon from '@material-ui/icons/Error'
import cx from 'classnames'
import useNotificationStyles from './Styles'
import { INotificationPageProps } from './Interfaces'
import { useMediaQuery, useTheme } from '@material-ui/core'

const NotificationPage: React.FC<INotificationPageProps> = ({ children, warning, size, title, subtitle }) => {
  const classes = useNotificationStyles({})

  const theme = useTheme()
  const downXS = useMediaQuery(theme.breakpoints.down('xs'))

  const titleSize = {
    small: '26px',
    normal: '40px',
    big: '55px'
  }

  let subtitleContentClass: string = null
  let warningIconClasses: string = null

  switch (size) {
    case 'small':
      subtitleContentClass = classes.smallContent
      warningIconClasses = classes.warningIcon
      break
    case 'big':
      subtitleContentClass = classes.bigContent
      warningIconClasses = cx(classes.warningIcon, classes.warningIconBig)
      break
    default:
      subtitleContentClass = classes.normalContent
      warningIconClasses = classes.warningIcon
      break
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.row}>
          {warning && <ErrorIcon className={warningIconClasses} />}
          <h1
            id="notification-page-title-label"
            className={classes.title}
            style={{ fontSize: downXS ? titleSize.normal : titleSize[size] }}
          >
            {title}
          </h1>
        </div>
      </div>
      <div className={classes.column}>
        <p
          id="notification-page-sub-title-label"
          className={cx(classes.content, subtitleContentClass)}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
        {children}
      </div>
    </div>
  )
}

NotificationPage.defaultProps = {
  size: 'normal'
}

export default NotificationPage
